import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import EditIcon from '@mui/icons-material/Edit';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import HeaderCard from '../General/HeaderCard';
import AuthorProfileBar from './AuthorProfileBar';
import BadgeCard from './BadgeCard';
import FollowButton from './FollowButton';

export default function BlogSidebar({ profile }) {
  const { about } = profile;

  const {
    website,
    twitter,
    facebook,
    instagram,
    youtube,
    pinterest,
    hive,
    following,
    followers,
    posts,
  } = profile;

  const renderFollowBtn = useMediaQuery('(max-width: 767px)');

  return (
    <div className="pr-2 pl-2 pt-2">
      <div className="pb-2">
        <HeaderCard
          noborder
          title={about ? 'Intro' : 'About'}
          titlesize="h6"
          bgCard
          content={
            <>
              <Typography
                variant="subtitle2"
                className="textSecondary pl-3 pr-3"
              >
                {about}
              </Typography>
              {renderFollowBtn && (
                <div className="pl-2 pt-1">
                  {getUser() === profile.author.username ? (
                    <Link href="/dashboard/profile">
                      <Button color="primary" variant="contained">
                        <EditIcon />
                        <span className="pl-1">Edit Profile</span>
                      </Button>
                    </Link>
                  ) : (
                    <FollowButton
                      author={profile.author.username}
                      btnstyle="solid"
                    />
                  )}
                </div>
              )}
              <Divider className="mt-3 mb-3" />
              <div className="row pb-3">
                <div className="col-4 text-center">
                  <Typography variant="h5" component="span">
                    {followers}
                  </Typography>{' '}
                  <Typography variant="subtitle2">Followers</Typography>
                </div>
                <div className="col-4 text-center">
                  <Typography variant="h5" component="span">
                    {following}
                  </Typography>{' '}
                  <Typography variant="subtitle2">Following</Typography>
                </div>
                <div className="col-4 text-center">
                  <Typography variant="h5" component="span">
                    {posts}
                  </Typography>{' '}
                  <Typography variant="subtitle2">Posts</Typography>
                </div>
              </div>
            </>
          }
        />
      </div>
      <div className="pb-2">
        {(website ||
          twitter ||
          facebook ||
          instagram ||
          youtube ||
          pinterest ||
          hive) && (
          <HeaderCard
            noborder
            title="Social Media"
            titlesize="h6"
            bgCard
            content={<AuthorProfileBar profile={profile} />}
          />
        )}
      </div>
      <BadgeCard user={profile.author.username} />
    </div>
  );
}
